import { ReactNode } from "react";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { ErrValidationFailedContextProvider } from "@/shared/lib/errors/err-validation-failed-context";

export function WorkOrderProviders({ children }: { children: ReactNode }) {
  return (
    <PersistenceContextProvider>
      <ErrValidationFailedContextProvider>
        {children}
      </ErrValidationFailedContextProvider>
    </PersistenceContextProvider>
  );
}
